import { takeLatest, put } from 'redux-saga/effects';
import { actions } from 'store/rootSlices';

function* onMountSaga() {
  yield put(actions.EnrollmentsProofs.setLoading(false));
}

function* onUnmountSaga() {}

export default function* watcherSignin() {
  yield takeLatest('EnrollmentsProofs/onMount', onMountSaga);
  yield takeLatest('EnrollmentsProofs/onUnmount', onUnmountSaga);
}
